<template>
  <v-form readonly>
    <v-card>
      <v-card-text>
        <v-text-field
          v-model="client.name"
          :readonly="!auth.user.isAdmin"
          label="Название"
        />
        <reference-field
          v-if="auth.user.isAdmin"
          v-model="client.partnerId"
          reference="partner"
          label="Партнер"
        />
        <v-text-field
          type="number"
          v-model="client.maxCashiers"
          :readonly="!auth.user.isAdmin"
          label="Количество аккаунтов"
        />
        <v-checkbox
          v-for="n in notifications"
          v-model="client.notifications"
          :label="n.label"
          :key="n.id"
          :value="n.id"
        >
        </v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="save()" v-if="auth.user.isAdmin">
          {{ this.client.id ? "Сохранить изменения" : "Создать клиента" }}
        </v-btn>
        <slot />
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import ds from "@/datastore";
import { auth } from "@/mixins";
import { AlertTypes } from "@/datastore/enums.js";
export default {
  name: "ClientForm",
  mixins: [auth],
  props: {
    id: String,
    value: Object
  },
  data() {
    return {
      client: {},
      notifications: AlertTypes
    };
  },
  async created() {
    if (!this.id) {
      this.client = ds.createRecord("client", this.value);
    } else {
      const item = await ds.find("client", this.id);
      this.client = ds.createRecord("client", item.toJSON());
    }
    this.client.maxCashiers = this.client.maxCashiers || 0;
    this.client.notifications = this.client.notifications || [];
  },
  methods: {
    async save() {
      let item = await this.client.save();
      this.$store.commit("notifications/success", "Клиент сохранен");
      this.$emit("input", item);
      this.$emit("saved", item);
      return item;
    }
  }
};
</script>
